import Grid from '@mui/material/Unstable_Grid2/Grid2'
import OneInput from '../../../../Components/OneInput/OneInput'
import OneButton from '../../../../Components/OneButton/OneButton'
import { Search } from '@mui/icons-material'
import { useContext, useState } from 'react'
import { VisitantesContext } from '../../../../Providers/VisitantesContext/VisitantesContext'
import { Typography } from '@mui/material'

const ProcurarVisitanteDentro = () => {
    const { pesquisaNomeCpfImovel, activeCond } = useContext(VisitantesContext)
    const [texto, setTexto] = useState('')

    const handleSubmit = (e) => {
        e.preventDefault()
        pesquisaNomeCpfImovel(texto)
    }

    return (
        <Grid xs={ 12 } component={'form'} onSubmit={handleSubmit} sx={{
            display: 'flex',
            width: '100%',
            height: '10%',
            borderBottom: '1px solid white',
            alignItems: 'center',
            justifyContent: 'space-around'
        }}>
            <Grid>
                <Typography sx={{ color: 'black', fontWeight: '600' }}>Nome, {activeCond.pais === 'es-CL' ? 'RUT' : 'CPF'}, Placa ou Imóvel:</Typography>
            </Grid>
            <OneInput
                newSx={{ width: '55%', height: '30px' }}
                onChange={(e) => {
                    setTexto(e.target.value)
                }}
            />
            <OneButton
                id="button"
                color="one_primary"
                backgroundColor="#0FBB00"
                variant="contained"
                IconStart={Search}
                type="submit"
            >
                Pesquisar
            </OneButton>
        </Grid>
    )
}

export default ProcurarVisitanteDentro
